import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'

import { Box, Columns, LoadingModule } from '@domain-group/suit-theme'

import useAgencyPublications from '@hooks/useAgencyPublications'
import useAgencySelector from '@hooks/useAgencySelector'
import useCurrentUser from '@hooks/useCurrentUser'

import NotificationBannerLocation from '@components/NotificationBannerLocation'
import NotificationModuleLocation from '@components/NotificationModuleLocation'
import PageHeader from '@components/PageHeader'

import DeadlinesBlankState from '../../../../components/DeadlinesBlankState'
import generateDeadlineTabItems from '../../../../components/utils/generateDeadlineTabItems'

import Deadline from '../Deadline'

const PageContent = () => {
  const { agencyIdParam, selectedAgencyId } = useAgencySelector()

  const { isAgent, isEbuAdmin } = useCurrentUser()

  useLocation()

  const agencyPublications = useAgencyPublications({
    filters: { agency_id: isAgent || isEbuAdmin ? undefined : selectedAgencyId },
    requestOptions: {
      include_agency_publication_publication: true,
      include_publication_logo: true,
      include_publication_next_edition: true,
    },
    performHttpRequests: !!agencyIdParam,
  })

  const { filteredAgencyPublications, hasFilteredAgencyPublications, loading } = agencyPublications

  // We need to find unique publication ids so we dont double render
  const publicationIds = filteredAgencyPublications.map(agencyPublication => agencyPublication.publication_id)
  // @ts-expect-error TS2802
  const uniquePublicationIds = [...new Set(publicationIds)]

  return (
    <>
      <Helmet>
        <title>Deadlines | Realhub</title>
      </Helmet>

      <PageHeader
        nestedNavigation
        activeTabBarItemKey="publication-deadlines"
        // @ts-expect-error TS2345
        tabBarItems={generateDeadlineTabItems(agencyIdParam)}
        title="Deadlines"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <NotificationBannerLocation
              locationKey="agency.agencyDashboard.deadlines.banner"
            />

            <LoadingModule loading={loading} times={3} />

            {!loading && !hasFilteredAgencyPublications && <DeadlinesBlankState />}

            {hasFilteredAgencyPublications && uniquePublicationIds.map(
              publicationId => <Deadline publicationId={publicationId} key={publicationId} />,

            )}
          </Columns.Main>

          <Columns.Sidebar>
            <NotificationModuleLocation
              locationKey="agency.agencyDashboard.deadlines.sidebar"
            />
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
